import React from 'react'
import PropTypes from 'prop-types'
import { Field, Form } from 'react-final-form'
import classNames from 'classnames'
import styles from './ticket-activities.module.scss'
import { TextareaInput } from '../../TextareaInput'
export default function EditCommentForm ({ onSubmit, disabled = false, initialValues, onClose }) {
  return (
    <Form onSubmit={onSubmit} validate={validate} initialValues={initialValues}>
      {({ handleSubmit, pristine, invalid, submitting }) => (
        <form className={classNames('dis-panel', styles.editCommentForm)} onSubmit={handleSubmit}>
          <Field
            name='comment'
            label='Edit Comment'
            component={TextareaInput}
          />
          <div className={styles.formButtonContainer}>
            <button
              type='button'
              className={classNames('dis-btn dis-btn-sm dis-btn-no-shadow', styles.editCommentFormButton)}
              onClick={onClose}
              disabled={disabled}>
              Cancel
              <i className='material-icons dis-btn-icon'>clear</i>
            </button>
            <button
              type='submit'
              className={classNames('dis-btn dis-btn-primary dis-btn-sm', styles.editCommentFormButton)}
              disabled={pristine || invalid || submitting || disabled}>
              Save
              <i className='material-icons dis-btn-icon'>check</i>
            </button>
          </div>
        </form>
      )}
    </Form>
  )
}

EditCommentForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  initialValues: PropTypes.object,
  onClose: PropTypes.func.isRequired
}

function validate (values) {
  const errors = {}

  if (!values.comment) {
    errors.comment = 'Required'
  }

  return errors
}
